import { client } from "../lib/Client";

export const isAdmin = async () => {
  const response = await client.get("auth/is-admin", {
    withCredentials: true,
  });
  return response.data.is_admin;
};

export const fetchAuthStatus = async () => {
  try {
    const response = await client.get("auth/is-authenticated", {
      withCredentials: true,
    });
    console.log("Auth response", response);
    return response.data.is_authenticated;
  } catch (error) {
    console.log("Auth check failed");
    return false;
  }
};
